export {
  ErrorRoot as Root,
  type ErrorRootProps as RootProps,
} from "./ErrorRoot";
export {
  ErrorMessage as Message,
  type ErrorMessageProps as MessageProps,
} from "./ErrorMessage";
